import { BlogPostStatusEnum } from './enums'

export const statusDotClasses: Record<BlogPostStatusEnum, string> = {
  [BlogPostStatusEnum.Published]: 'bg-[#12B76A]',
  [BlogPostStatusEnum.Draft]: 'bg-[#98A2B3]',
  [BlogPostStatusEnum.Scheduled]: 'bg-[#F79009]',
}

export const statusLabel: Record<BlogPostStatusEnum, string> = {
  [BlogPostStatusEnum.Draft]: 'website_settings.blog.post_status.draft',
  [BlogPostStatusEnum.Scheduled]: 'website_settings.blog.post_status.scheduled',
  [BlogPostStatusEnum.Published]: 'website_settings.blog.post_status.published',
}
